import React, { Component } from "react";
import { Button, FormGroup, FormControl, FormLabel } from "react-bootstrap";
import {errorMessage} from "../database/apiMethods"
import {apiUpdatePwd} from './ResetCode'
import {getQueryParam} from '../Utils/urls';
import {EmailInput, PasswordInput, RepeatPasswordInput} from './FormInputs'
import BannerMessage from "./Banner";

import "./Login.css";
import {Link} from "react-router-dom";

export default class CreateUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      resetcode: "",
      password: "",
      confirmpassword: "",
      apiPending: false,
      alertShown: false,
      alertMsg: "",
      resetDone: false,
    };
    this.closeAlert = this.closeAlert.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    const activationLink = this.props.location.state;
    const constUrl = "/activate?activateToken=";
    if ('undefined' !== typeof activationLink) {
      const tokenAt = activationLink.indexOf(constUrl);
      this.token = activationLink.substring(tokenAt+constUrl.length, activationLink.length);
    }
    else {
      this.token = getQueryParam(props).get("activateToken");
    }
  }
 
  validateForm() {
    return this.state.password.length > 4 && 
           (this.state.password.localeCompare(this.state.confirmpassword) === 0);
  }

  buttonDisabled () {
    return !this.validateForm() || this.state.apiPending;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      apiPending: false
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState ({apiPending: true });
    const st = this.state
    const resp = await apiUpdatePwd(st.email, st.password, st.resetcode)
    const msg = errorMessage (resp);
    const problem = resp instanceof Error || msg?.length;
    this.setState ({alertShown: problem, resetDone: !problem, alertMsg: msg, apiPending: false})
  }

  closeAlert () {
    this.setState({alertShown: false});
  }

  resetComplete() {
    return ( this.state.resetDone ? 
      <div className='alert alert-success create-fail formcenter' 
        onClick={()=>this.props.history.push('./login')}>
        Password Reset! Click here to login
      </div>
      : null
    )
  }

  render() {
    const pwdOpt={"autoComplete":"new-password"}
    return (
      <div className="pagebg">
      <div className="reset-pwd">
       <form className="login-width" onSubmit={this.handleSubmit}>
         <img src="tehama_logo_100p.png" className="login-logo" alt="Tehama Logo"></img>
          <div className="login-title formtitle">Reset password</div>
          <EmailInput onChange={this.handleChange} value={this.state.email} autoFocus />
          <FormGroup controlId="resetcode" >
            <FormLabel className='formLabel'>Reset code</FormLabel>
            <FormControl className='formField'
              value={this.state.resetcode}
              onChange={this.handleChange}
              type="text"
            />
          </FormGroup>
          <PasswordInput onChange={this.handleChange} value={this.state.password} options={pwdOpt}/>
          <RepeatPasswordInput onChange={this.handleChange} value={this.state.confirmpassword} />
          <div className="d-grid gap-2">
            <Button className="button-style" disabled={this.buttonDisabled()}
              type="submit">Reset
            </Button>
          </div>
          <div className="activate-link darker-anchor"> <Link to="/login">Back to Login page</Link></div> 
        </form>
        <BannerMessage msg={this.state.alertMsg} show={this.state.alertShown} 
                      variant="alert-danger create-fail" close={this.closeAlert} />
        {this.resetComplete()}
      </div>
      </div>
    );
  }
}
